function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3879",
  "data-name": "Rectangle 3879",
  width: 220.5,
  height: 189.5,
  transform: "translate(638.789 126.79)",
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5394",
  "data-name": "Group 5394",
  transform: "translate(-518.82 -126.79)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5375",
  "data-name": "Group 5375"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5370",
  "data-name": "Group 5370"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5369",
  "data-name": "Group 5369"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3867",
  "data-name": "Rectangle 3867",
  width: 46.078,
  height: 26.539,
  transform: "translate(609.507 260.377)",
  fill: "#fbd260",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9079",
  "data-name": "Path 9079",
  d: "M655.553,260.349H609.5l5.757,5.147,4.038,3.61,1.718,1.536,5.375,4.806,4.42,3.949a2.647,2.647,0,0,0,3.437,0l4.419-3.949,5.375-4.806,1.719-1.536,4.037-3.61Z",
  fill: "#c3e8fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9080",
  "data-name": "Path 9080",
  d: "M655.553,260.349H609.5l5.757,4.911L619.3,268.7l1.718,1.465,5.375,4.586,4.42,3.768a2.745,2.745,0,0,0,3.437,0l4.419-3.768,5.375-4.586,1.719-1.465,4.037-3.444Z",
  fill: "#fbd260",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_83",
  "data-name": "Line 83",
  y1: 13.244,
  x2: 15.338,
  transform: "translate(609.681 273.486)",
  fill: "none",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_84",
  "data-name": "Line 84",
  x1: 15.339,
  y1: 13.244,
  transform: "translate(640.21 273.486)",
  fill: "none",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5372",
  "data-name": "Group 5372"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5371",
  "data-name": "Group 5371"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3868",
  "data-name": "Rectangle 3868",
  width: 46.078,
  height: 26.539,
  transform: "translate(560.804 206.817)",
  fill: "#fbd260",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9081",
  "data-name": "Path 9081",
  d: "M606.849,206.789H560.8l5.757,5.147,4.038,3.61,1.718,1.535,5.375,4.807,4.419,3.95a2.651,2.651,0,0,0,3.438,0l4.418-3.95,5.375-4.807c.624-.557,1.246-1.113,1.72-1.535l4.037-3.61Z",
  fill: "#c3e8fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9082",
  "data-name": "Path 9082",
  d: "M606.849,206.789H560.8l5.757,4.911,4.038,3.444,1.718,1.465,5.375,4.586,4.419,3.769a2.749,2.749,0,0,0,3.438,0l4.418-3.769,5.375-4.586,1.72-1.465,4.037-3.444Z",
  fill: "#fbd260",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_85",
  "data-name": "Line 85",
  y1: 13.244,
  x2: 15.337,
  transform: "translate(560.978 219.927)",
  fill: "none",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_86",
  "data-name": "Line 86",
  x1: 15.339,
  y1: 13.244,
  transform: "translate(591.507 219.927)",
  fill: "none",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5373",
  "data-name": "Group 5373"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_87",
  "data-name": "Line 87",
  x2: 44.025,
  transform: "translate(553.172 276.531)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_88",
  "data-name": "Line 88",
  x2: 44.025,
  transform: "translate(559.754 270.167)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_89",
  "data-name": "Line 89",
  x2: 5.759,
  transform: "translate(550.704 270.167)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_90",
  "data-name": "Line 90",
  x2: 5.758,
  transform: "translate(544.123 276.531)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5374",
  "data-name": "Group 5374"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_91",
  "data-name": "Line 91",
  x2: 17.276,
  transform: "translate(527.87 219.782)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_92",
  "data-name": "Line 92",
  x2: 17.277,
  transform: "translate(534.451 213.418)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_93",
  "data-name": "Line 93",
  x2: 5.758,
  transform: "translate(525.402 213.418)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_94",
  "data-name": "Line 94",
  x2: 5.759,
  transform: "translate(518.82 219.782)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_5377",
  "data-name": "Group 5377"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5376",
  "data-name": "Group 5376"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3869",
  "data-name": "Rectangle 3869",
  width: 54.886,
  height: 31.611,
  transform: "translate(858.813 278.894)",
  fill: "#f6fafb",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9083",
  "data-name": "Path 9083",
  d: "M913.66,278.861H858.807l6.857,6.131,4.81,4.3,2.047,1.829,6.4,5.725,5.264,4.7a3.154,3.154,0,0,0,4.094,0l5.264-4.7,6.4-5.725,2.048-1.829,4.809-4.3Z",
  fill: "#c3e8fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9084",
  "data-name": "Path 9084",
  d: "M913.66,278.861H858.807l6.857,5.85,4.81,4.1,2.047,1.746,6.4,5.461,5.264,4.49a3.273,3.273,0,0,0,4.094,0l5.264-4.49,6.4-5.461c.744-.633,1.485-1.266,2.048-1.746l4.809-4.1Z",
  fill: "#f6fafb",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_95",
  "data-name": "Line 95",
  y1: 15.775,
  x2: 18.27,
  transform: "translate(859.021 294.51)",
  fill: "none",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_96",
  "data-name": "Line 96",
  x1: 18.271,
  y1: 15.775,
  transform: "translate(895.386 294.51)",
  fill: "none",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5379",
  "data-name": "Group 5379"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5378",
  "data-name": "Group 5378"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3870",
  "data-name": "Rectangle 3870",
  width: 54.886,
  height: 31.611,
  transform: "translate(837.813 188.899)",
  fill: "#f6fafb",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9085",
  "data-name": "Path 9085",
  d: "M892.66,188.866H837.807L844.664,195l4.81,4.3,2.047,1.829,6.4,5.724,5.264,4.706a3.156,3.156,0,0,0,4.094,0l5.264-4.706,6.4-5.724,2.048-1.829L885.8,195Z",
  fill: "#c3e8fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9086",
  "data-name": "Path 9086",
  d: "M892.66,188.866H837.807l6.857,5.85,4.81,4.1c.562.48,1.3,1.113,2.047,1.745l6.4,5.462,5.264,4.49a3.273,3.273,0,0,0,4.094,0l5.264-4.49,6.4-5.462c.744-.632,1.485-1.265,2.048-1.745l4.809-4.1Z",
  fill: "#f6fafb",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_97",
  "data-name": "Line 97",
  y1: 15.775,
  x2: 18.27,
  transform: "translate(838.021 204.515)",
  fill: "none",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_98",
  "data-name": "Line 98",
  x1: 18.271,
  y1: 15.775,
  transform: "translate(874.386 204.515)",
  fill: "none",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5381",
  "data-name": "Group 5381"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5380",
  "data-name": "Group 5380"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3871",
  "data-name": "Rectangle 3871",
  width: 54.886,
  height: 31.611,
  transform: "translate(912.416 231.396)",
  fill: "#f6fafb",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9087",
  "data-name": "Path 9087",
  d: "M967.263,231.363H912.409l6.858,6.131,4.809,4.3c.563.5,1.3,1.165,2.047,1.829l6.4,5.725,5.264,4.7a3.155,3.155,0,0,0,4.095,0l5.264-4.7,6.4-5.725,2.048-1.829,4.808-4.3Z",
  fill: "#c3e8fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9088",
  "data-name": "Path 9088",
  d: "M967.263,231.363H912.409l6.858,5.85,4.809,4.1,2.047,1.745,6.4,5.462,5.264,4.49a3.274,3.274,0,0,0,4.095,0l5.264-4.49,6.4-5.462c.743-.632,1.484-1.265,2.048-1.745l4.808-4.1Z",
  fill: "#f6fafb",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_99",
  "data-name": "Line 99",
  y1: 15.775,
  x2: 18.27,
  transform: "translate(912.623 247.012)",
  fill: "none",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_100",
  "data-name": "Line 100",
  x1: 18.271,
  y1: 15.775,
  transform: "translate(948.988 247.012)",
  fill: "none",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5382",
  "data-name": "Group 5382"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_101",
  "data-name": "Line 101",
  x2: 20.579,
  transform: "translate(885.188 246.84)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_102",
  "data-name": "Line 102",
  x2: 20.579,
  transform: "translate(893.027 239.26)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_103",
  "data-name": "Line 103",
  x2: 6.859,
  transform: "translate(882.248 239.26)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_104",
  "data-name": "Line 104",
  x2: 6.859,
  transform: "translate(874.408 246.84)",
  fill: "none",
  stroke: "#368cb2",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5388",
  "data-name": "Group 5388"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5387",
  "data-name": "Group 5387"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3872",
  "data-name": "Rectangle 3872",
  d: "M8.656,0h234.76a8.657,8.657,0,0,1,8.657,8.657v151.18a8.658,8.658,0,0,1-8.658,8.658H8.658A8.658,8.658,0,0,1,0,159.837V8.656A8.656,8.656,0,0,1,8.656,0Z",
  transform: "translate(624.336 171.282)",
  fill: "#cdd5d7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3873",
  "data-name": "Rectangle 3873",
  d: "M7.846,0H242.6a7.845,7.845,0,0,1,7.845,7.845V159.027a7.846,7.846,0,0,1-7.846,7.846H7.844A7.844,7.844,0,0,1,0,159.029V7.846A7.846,7.846,0,0,1,7.846,0Z",
  transform: "translate(625.148 172.093)",
  fill: "#41a9d8",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_5383",
  "data-name": "Group 5383"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3874",
  "data-name": "Rectangle 3874",
  width: 223.891,
  height: 132.706,
  transform: "translate(638.428 184.351)",
  fill: "#c3e8fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9089",
  "data-name": "Path 9089",
  d: "M861.318,185.351V316.057H639.428V185.351h221.89m2-2H637.428V318.057h225.89V183.351Z",
  fill: "#368cb2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5384",
  "data-name": "Group 5384"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9090",
  "data-name": "Path 9090",
  d: "M750.094,177.551a1.052,1.052,0,1,1-1.054-1.05A1.055,1.055,0,0,1,750.094,177.551Z",
  fill: "#e5e8ec"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_9091",
  "data-name": "Path 9091",
  d: "M741.306,182.738l4.287-10.1h-35.31L706,182.738Z",
  fill: "#47b8eb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9092",
  "data-name": "Path 9092",
  d: "M650.2,319.277l-7.8,20.133H677l7.8-20.133Z",
  fill: "#47b8eb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9093",
  "data-name": "Path 9093",
  d: "M764.006,182.738l4.287-10.1H756.941l-4.286,10.1Z",
  fill: "#47b8eb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9094",
  "data-name": "Path 9094",
  d: "M695.936,319.277l-7.807,20.133h11.125l7.806-20.133Z",
  fill: "#47b8eb"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3875",
  "data-name": "Rectangle 3875",
  width: 336.5,
  height: 9.844,
  transform: "translate(582.121 330.081)",
  fill: "#f6fafb",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_5385",
  "data-name": "Group 5385"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9095",
  "data-name": "Path 9095",
  d: "M582.614,339.925c3.977,4.209,11.294,5.863,16.342,5.863H901.784c5.049,0,12.368-1.654,16.344-5.863Z",
  fill: "#c3e8fa",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5386",
  "data-name": "Group 5386"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9096",
  "data-name": "Path 9096",
  d: "M727.516,330.081v1.055a3.515,3.515,0,0,0,3.514,3.518h38.684a3.517,3.517,0,0,0,3.516-3.518v-1.055Z",
  fill: "#c3e8fa",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_5393",
  "data-name": "Group 5393"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5392",
  "data-name": "Group 5392",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5391",
  "data-name": "Group 5391"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3876",
  "data-name": "Rectangle 3876",
  width: 197.066,
  height: 113.828,
  transform: "translate(651.762 220.537)",
  fill: "#41a9d8",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9097",
  "data-name": "Path 9097",
  d: "M651.74,220.613H848.873L824.234,199.6l-17.283-14.745c-2.035-1.725-4.693-4-7.359-6.273l-23.01-19.618-18.916-16.14a11.754,11.754,0,0,0-14.715,0l-18.924,16.14L701.02,178.58c-2.662,2.275-5.329,4.548-7.354,6.273L676.381,199.6Z",
  fill: "#47b8eb",
  stroke: "#368cb2",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3877",
  "data-name": "Rectangle 3877",
  width: 172.279,
  height: 150.51,
  transform: "translate(663.652 155.181)",
  fill: "#f6fafb",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_5389",
  "data-name": "Group 5389"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3878",
  "data-name": "Rectangle 3878",
  width: 93,
  height: 3,
  transform: "translate(677.668 175.79)",
  fill: "#47b8eb"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_105",
  "data-name": "Line 105",
  x2: 145,
  transform: "translate(678.668 192.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_106",
  "data-name": "Line 106",
  x2: 145,
  transform: "translate(678.668 200.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_107",
  "data-name": "Line 107",
  x2: 145,
  transform: "translate(678.668 208.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_108",
  "data-name": "Line 108",
  x2: 145,
  transform: "translate(678.668 216.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_109",
  "data-name": "Line 109",
  x2: 145,
  transform: "translate(678.668 224.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_110",
  "data-name": "Line 110",
  x2: 145,
  transform: "translate(678.668 232.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_111",
  "data-name": "Line 111",
  x2: 145,
  transform: "translate(678.668 240.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_112",
  "data-name": "Line 112",
  x2: 145,
  transform: "translate(678.668 248.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_113",
  "data-name": "Line 113",
  x2: 145,
  transform: "translate(678.668 256.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_114",
  "data-name": "Line 114",
  x2: 145,
  transform: "translate(678.668 264.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_115",
  "data-name": "Line 115",
  x2: 145,
  transform: "translate(678.668 272.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_116",
  "data-name": "Line 116",
  x2: 145,
  transform: "translate(678.668 280.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_117",
  "data-name": "Line 117",
  x2: 145,
  transform: "translate(678.668 288.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_118",
  "data-name": "Line 118",
  x2: 145,
  transform: "translate(678.668 296.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_119",
  "data-name": "Line 119",
  x2: 145,
  transform: "translate(678.668 304.29)",
  fill: "none",
  stroke: "#bae5f8",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_9098",
  "data-name": "Path 9098",
  d: "M848.738,220.757l-24.509,20.9-17.286,14.745c-2.027,1.721-4.689,4-7.353,6.272l-17.213,14.682H718.233L701.02,262.679c-2.662-2.275-5.329-4.551-7.358-6.272l-17.281-14.745-24.512-20.9h-.107V334.364H849V220.757Z",
  fill: "#fbd260",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_5390",
  "data-name": "Group 5390"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9099",
  "data-name": "Path 9099",
  d: "M652.336,333.623l24.045-20.444,17.281-14.86c2.029-1.741,4.7-4.035,7.358-6.325l17.117-14.715",
  fill: "#c3e8fa",
  stroke: "#368cb2",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9100",
  "data-name": "Path 9100",
  d: "M782.473,277.279l17.117,14.715c2.664,2.29,5.326,4.584,7.353,6.325l17.286,14.86,24.644,21.185",
  fill: "#c3e8fa",
  stroke: "#368cb2",
  strokeWidth: 2
}))))));

function SvgSignupSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 449.481,
    height: 219.997,
    viewBox: "0 0 449.481 219.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupSuccessIcon);
export default __webpack_public_path__ + "static/media/signup-success-icon.4c557cff.svg";
export { ForwardRef as ReactComponent };